import { Stripe, PaymentMethod } from '@stripe/stripe-js';
import { createSubscription } from './create-subscription';
import { ProcessingParams } from '../../types/stripe/processing-params';
import { retryInvoiceWithNewPaymentMethod } from './retry-with-new-method';
import { Coupon } from '@services/product/types/coupon';
import { CustomerMetadata } from '../../../../../services/payment/types/api/customer-metadata';

export const subscriptionFlow = async (
  stripe: Stripe,
  paymentMethod: PaymentMethod,
  clientId: string,
  priceId: string,
  subscriptionId: string,
  customer: CustomerMetadata,
  externalSubscriptionId?: string,
  coupon?: Coupon,
  isNew?: boolean,
  trialDays?: number
): Promise<ProcessingParams> => {
  const latestInvoicePaymentIntentStatus = localStorage.getItem(
    'latestInvoicePaymentIntentStatus'
  );
  const invoiceId = localStorage.getItem('latestInvoiceId');

  if (
    latestInvoicePaymentIntentStatus === 'requires_payment_method' &&
    invoiceId
  ) {
    // Update the payment method and retry invoice payment
    await retryInvoiceWithNewPaymentMethod(
      stripe,
      clientId,
      paymentMethod.id,
      invoiceId as string,
      priceId,
      customer
    );

    localStorage.removeItem('latestInvoicePaymentIntentStatus');
    localStorage.removeItem('latestInvoiceId');
  }

  // Create the subscription
  return createSubscription(
    stripe,
    clientId,
    paymentMethod.id,
    priceId,
    subscriptionId,
    customer,
    externalSubscriptionId,
    coupon,
    isNew,
    trialDays
  );
};
